<template>
  <div class="app-main-content">
    <subscribe-port-service-view v-if="$store.getters.tenantId===1" />
    <div v-if="$store.getters.tenantId!==1" class="tabs-container">
      <el-tabs v-model="activeTabName" type="card" style="width: 100%" @tab-click="handleTabClick">
        <el-tab-pane :key="10" :lazy="true" :label="$t('SystemMaintenance.MaritimeDataPush')" name="sea">
          <subscribe-port-push-rule-view />
        </el-tab-pane>
        <el-tab-pane :key="11" :lazy="true" :label="$t('SystemMaintenance.AirFreightDataPush')" name="air">
          <subscribe-air-port-push-rule-view />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import SubscribePortPushRuleView from '@/views/cargo/v0/SystemMaintenance/components/subscribePortPushRuleView'
import SubscribePortServiceView from '@/views/cargo/v0/SystemMaintenance/components/subscribePortServiceView'
import SubscribeAirPortPushRuleView from '@/views/cargo/v0/SystemMaintenance/components/subscribeAirPortPushRuleView'
import LocalStorageUtils from '@/utils/localStorageUtils'

export default {
  name: 'SubscribePortService',
  components: { SubscribeAirPortPushRuleView, SubscribePortPushRuleView, SubscribePortServiceView },
  data() {
    return {
      activeTabName: 'sea'
    }
  },
  watch: {
    activeTabName(val) {
      LocalStorageUtils.setConfiguration('SubscribePortService', val)
    }
  },
  created() {
    const activeTab = LocalStorageUtils.getConfiguration('SubscribePortService')
    if (activeTab) {
      this.activeTabName = activeTab
    }
  },
  methods: {
    handleTabClick() {
    }
  }
}
</script>

<style scoped>

</style>
